import { TriangleAlertIcon } from "lucide-react";
import React from "react";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { useIntl } from "react-intl";

interface ErrorBoundaryWrapperProps {
  children: React.ReactNode;
}

function ErrorFallback({ error }: { error: Error }) {
  const { formatMessage } = useIntl();
  const { resetBoundary } = useErrorBoundary();

  return (
    <div className="flex items-center justify-center min-h-screen bg-muted">
      <div className="max-w-md w-full bg-card shadow-lg rounded-lg p-8 text-center">
        <TriangleAlertIcon className="mx-auto h-12 w-12 text-yellow-400" />
        <h2 className="mt-4 text-xl font-semibold text-foreground">
          {formatMessage({ id: "errorBoundary.title" })}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {formatMessage({ id: "errorBoundary.description" })}
        </p>
        <div className="mt-4 p-3 bg-red-50 rounded-md">
          <p className="text-sm font-mono text-red-800">{error.message}</p>
        </div>
        <button
          onClick={resetBoundary}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-300 ease-in-out"
        >
          {formatMessage({ id: "errorBoundary.tryAgain" })}
        </button>
      </div>
    </div>
  );
}

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({
  children,
}) => (
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onReset={() => window.location.reload()}
  >
    {children}
  </ErrorBoundary>
);

export default ErrorBoundaryWrapper;
